(function(site,$){
	"use strict";
(function($){
	var initialDisplayNumber = 5;
	var arrowCounter = 0;
	var maxArrowCount = 0;
	var previousMaxCount = 0;
	var finalStringContainer = '';
	var allData = [];
	var $window = $(window),
		$dom = {},
		trace = {push: function() {}},
		firstSlide = false,
		selectors = {
			wrap : '.news-carousel',
			holder : '> .holder',
			thumbs : '.thumbs',
			thumb : '.thumb',
			aL: '.arrow-left',
			aR: '.arrow-right'
		},
		$arrowL = $('<button type="button" class="arrow-left hidden hoverable" aria-hidden="true">'
			+ '<i class="fa fa-chevron-left" aria-hidden="true"></i>'
			+ '</button>'
		),
		$arrowR = $('<button type="button" class="arrow-right hoverable" aria-hidden="true">'
			+ '<i class="fa fa-chevron-right" aria-hidden="true"></i>'
			+ '</button>'
		);

	/**
	 * Sidescroller Initializer
	 */
	function init() {

		// register modules/libraries for local use
		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};

		// cache DOM elements
		$dom.scroller = $(selectors.wrap);
		if(!$dom.scroller.length){
			return;
		}

		checkOverflows();

		$window.on('resize', function(){
			checkOverflows();
		});
	}

	/**
	 * Check content size to container size to determine if arrows are needed and add/remove accordingly
	 */
	function checkOverflows(){
		$dom.scroller.each(function(i,$elm){
			$elm = $($elm);
			var thumbsW = Math.floor($(selectors.holder,$elm)[0].scrollWidth),
				holderW = Math.floor($(selectors.thumbs,$elm).outerWidth()),
				$aR = $arrowR.clone(),
				$aL = $arrowL.clone();

			if(thumbsW > holderW){
				if(!$elm.find('> button').length) {
					trace.push('adding arrows to ',$elm);
					$elm.append($aR).append($aL);
					setListeners($elm, $aR, $aL);
				}
			}
			else {
				if($elm.find('> button').length) {
					trace.push('removing arrows from ',$elm);
					$elm.find('> button').off('click').remove();
				}
			}
		});
	}

	/**
	 * Set arrow listeners for given sidescroller
	 * @param {object} $elm the sidescroller
	 * @param {object} $aR  the right arrow
	 * @param {object} $aL  the left arrow
	 */
	function setListeners($elm, $aR, $aL) {
		$aL.on('click', function() {
			scrollContent($elm,'left');
			arrowCounter--;
			if(previousMaxCount < maxArrowCount){
				previousMaxCount = maxArrowCount;
			}
		});

		$aR.on('click', function() {
			if(!firstSlide) firstSlide = !firstSlide;
			scrollContent($elm,'right');
				if(arrowCounter < allData.length-initialDisplayNumber +2){
					if(arrowCounter < maxArrowCount){
						arrowCounter++;
					}
					else{
						previousMaxCount = arrowCounter;
						arrowCounter++;
						maxArrowCount = arrowCounter;
					}
				}
			if(arrowCounter < allData.length-initialDisplayNumber && maxArrowCount > previousMaxCount){
				var title = '';
				if(allData[initialDisplayNumber + maxArrowCount].field_newsroom_featured_title != '') {
					title = allData[initialDisplayNumber + maxArrowCount].field_newsroom_featured_title;
				} else {
					title = allData[initialDisplayNumber + maxArrowCount].title;
				}
				var titlelen = title.length;
				var titletrim = titlelen >= 100 ? title.substr(0, 100) + '...' : title;
				var newsroom_img = '';
				var newsroom_img_alt = '';
				if(allData[initialDisplayNumber + maxArrowCount].field_image) {
					newsroom_img = allData[initialDisplayNumber + maxArrowCount].field_image;
					newsroom_img_alt = allData[initialDisplayNumber + maxArrowCount].field_image_1;
				} else if(allData[initialDisplayNumber + maxArrowCount].field_fallback_division_image) {
					newsroom_img = allData[initialDisplayNumber + maxArrowCount].field_fallback_division_image;
					newsroom_img_alt = allData[initialDisplayNumber + maxArrowCount].field_fallback_division_image_1;
				} else {
					newsroom_img ="/themes/custom/universal/src/img/default_newsroom.jpg";
					newsroom_img_alt = 'NBCuniversal';
				}
				$(".news-item-container").append("<a href=" + allData[initialDisplayNumber + maxArrowCount].view_node + " target='_blank'><div class='thumb hoverable'><div class='back'></div><div class='holder img-holder'><div class='roll-img'><img src=" + newsroom_img + " alt='" + newsroom_img_alt + "'><span class='icon news-more-icon'><svg class='more-icon-svg' viewbox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'><circle class='more-icon-svg-circle' cx='50' cy='50' r='48' transform='rotate(-135,50,50) translate(0,0)' /><circle class='more-icon-svg-rollover' cx='50' cy='50' r='48' transform='rotate(-135,50,50) translate(0,0)' /><polyline class='more-icon-svg-arrow' stroke='#FFFFFF' points='39.7068966 37.5666667 51.0517241 49 39.7068966 60.4333333'></polyline><path class='more-icon-svg-arrow' d='M50.2413793,49 L0.810344828,49' stroke='#FFFFFF'></path></svg></span></div><div class='info'><div class='info-bg'></div><div class='group'> " + allData[initialDisplayNumber + maxArrowCount].field_home_newsroom_brand + " </div><div class='info-wrap'><div class='heading'>" + titletrim + "</div></div><div class='date'>" + allData[initialDisplayNumber + maxArrowCount].field_date + "</div></div></div></div></a>")
				$('.news-item-container').find("a .thumb .img-holder").each(function(el){
					var imageUrl = $(this).find('.roll-img img').attr('src');
					$(this).find('.info-bg').css('background-image', 'url(' + imageUrl + ')');
					$(this).removeClass('img-holder');
				});
			}
		});

		$elm.on('swipeleft', function(){
			scrollContent($elm,'right');
			if(arrowCounter < allData.length-initialDisplayNumber +2){
				if(arrowCounter < maxArrowCount){
					arrowCounter++;
				}
				else{
					previousMaxCount = arrowCounter;
					arrowCounter++;
					maxArrowCount = arrowCounter;
				}
			}
		if(arrowCounter < allData.length-initialDisplayNumber && maxArrowCount > previousMaxCount){
			var title = '';
			if(allData[initialDisplayNumber + maxArrowCount].field_newsroom_featured_title != '') {
				title = allData[initialDisplayNumber + maxArrowCount].field_newsroom_featured_title;
			} else {
				title = allData[initialDisplayNumber + maxArrowCount].title;
			}
			var titlelen = title.length;
			var titletrim = titlelen >= 100 ? title.substr(0, 100) + '...' : title;
			var newsroom_img = '';
			var newsroom_img_alt = '';
			if(allData[initialDisplayNumber + maxArrowCount].field_image) {
				newsroom_img = allData[initialDisplayNumber + maxArrowCount].field_image;
				newsroom_img_alt = allData[initialDisplayNumber + maxArrowCount].field_image_1;
			} else if(allData[initialDisplayNumber + maxArrowCount].field_fallback_division_image) {
				newsroom_img = allData[initialDisplayNumber + maxArrowCount].field_fallback_division_image;
				newsroom_img_alt = allData[initialDisplayNumber + maxArrowCount].field_fallback_division_image_1;
			} else {
				newsroom_img ="/themes/custom/universal/src/img/default_newsroom.jpg";
				newsroom_img_alt = 'NBCuniversal';
			}

			$(".news-item-container").append("<a href=" + allData[initialDisplayNumber + maxArrowCount].view_node + " target='_blank'><div class='thumb hoverable'><div class='back'></div><div class='holder img-holder'><div class='roll-img'><img src=" + newsroom_img + " alt='" + newsroom_img_alt + "'><span class='icon news-more-icon'><svg class='more-icon-svg' viewbox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'><circle class='more-icon-svg-circle' cx='50' cy='50' r='48' transform='rotate(-135,50,50) translate(0,0)' /><circle class='more-icon-svg-rollover' cx='50' cy='50' r='48' transform='rotate(-135,50,50) translate(0,0)' /><polyline class='more-icon-svg-arrow' stroke='#FFFFFF' points='39.7068966 37.5666667 51.0517241 49 39.7068966 60.4333333'></polyline><path class='more-icon-svg-arrow' d='M50.2413793,49 L0.810344828,49' stroke='#FFFFFF'></path></svg></span></div><div class='info'><div class='info-bg'></div><div class='group'> " + allData[initialDisplayNumber + maxArrowCount].field_home_newsroom_brand + " </div><div class='info-wrap'><div class='heading'>" + titletrim + "</div></div><div class='date'>" + allData[initialDisplayNumber + maxArrowCount].field_date + "</div></div></div></div></a>")
			$('.news-item-container').find("a .thumb .img-holder").each(function(el){
				var imageUrl = $(this).find('.roll-img img').attr('src');
				$(this).find('.info-bg').css('background-image', 'url(' + imageUrl + ')');
				$(this).removeClass('img-holder');
			});
		}
		}).on('swiperight', function(){
			scrollContent($elm,'left');
			arrowCounter--;
			if(previousMaxCount < maxArrowCount){
				previousMaxCount = maxArrowCount;
			}
		});
	}

/* 	$(document).ready(function(){
		var current_home = location.pathname;
		if(current_home == '/'){
			 $.get( "api/newsroom", function( data ) {
				if(data.length < initialDisplayNumber){
					initialDisplayNumber = data.length
				}
				allData = data

				for (var i = 0; i < data.length; i++) {
					var room = data[i];
					var newsroom_img = '';
					var newsroom_img_alt = '';
					if(data[i].field_image) {
						newsroom_img = data[i].field_image;
						newsroom_img_alt = data[i].field_image_1;
					} else if(data[i].field_fallback_division_image) {
						newsroom_img = data[i].field_fallback_division_image;
						newsroom_img_alt = data[i].field_fallback_division_image_1;
					} else {
						newsroom_img ="/themes/custom/universal/src/img/default_newsroom.jpg";
						newsroom_img_alt = 'NBCuniversal';
					}

					var title = '';
					if(data[i].field_newsroom_featured_title != '') {
						title = data[i].field_newsroom_featured_title;
					} else {
						title = data[i].title;
					}

					var titlelen = title.length;
					var titletrim = titlelen >= 100 ? title.substr(0, 100) + '...' : title;
					var originalString = "<a href=" + data[i].view_node + " target='_blank'><div class='thumb hoverable'><div class='back'></div><div class='holder img-holder'><div class='roll-img'><img src="+ newsroom_img +" alt='"+ newsroom_img_alt +"'><span class='icon news-more-icon'><svg class='more-icon-svg' viewbox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'><circle class='more-icon-svg-circle' cx='50' cy='50' r='48' transform='rotate(-135,50,50) translate(0,0)' /><circle class='more-icon-svg-rollover' cx='50' cy='50' r='48' transform='rotate(-135,50,50) translate(0,0)' /><polyline class='more-icon-svg-arrow' stroke='#FFFFFF' points='39.7068966 37.5666667 51.0517241 49 39.7068966 60.4333333'></polyline><path class='more-icon-svg-arrow' d='M50.2413793,49 L0.810344828,49' stroke='#FFFFFF'></path></svg></span></div><div class='info'><div class='info-bg'></div><div class='group'> " + data[i].field_home_newsroom_brand + " </div><div class='info-wrap'><div class='heading'>" + titletrim + "</div></div><div class='date'>" + data[i].field_date + "</div></div></div></div></a>";
					if(i <= initialDisplayNumber){
						finalStringContainer = finalStringContainer + originalString;
					}
				}
				finalStringContainer = encodeURIComponent(finalStringContainer);
				$('.news-item-container').html('').append(
					decodeURIComponent(finalStringContainer)
				)
				$('.news-item-container').find("a .thumb .img-holder").each(function(el){
					var imageUrl = $(this).find('.roll-img img').attr('src');
					$(this).find('.info-bg').css('background-image', 'url(' + imageUrl + ')');
					$(this).removeClass('img-holder');
				});
			 });
		}
   });
 */
	/**
	 * Scroll Content Left/Right
	 * @param  {string} dir "left" or "right" direction to scroll
	 */
	function scrollContent($elm,dir) {
			var $holder = $(selectors.holder,$elm),
			$thumb = $(selectors.thumb,$holder),
			thumbW = $thumb.width(),
			method = dir == 'left' ? '-=' : '+=';

		var $arrowL = $(selectors.aL,$elm);
		var $arrowR = $(selectors.aR,$elm);

		if(firstSlide) $arrowL.removeClass('hidden');

		$holder.animate({ 'scrollLeft': method+thumbW, }, 500, 'swing');
		var breakpoint = site.getBreakPoint();
		trace.push('breakpoint = '+breakpoint);
		if(breakpoint == "bp-large") {
			setTimeout(function(){
				toggleArrows($holder, $thumb, dir, $arrowL, $arrowR);
			}, 250);
		}

	}

	function toggleArrows($holder, $thumb, dir, $arrowL, $arrowR) {

		var windowW = $window.width(),
			holderW = $holder[0].scrollWidth,
			thumbW = $thumb.width(),
			thumbLeft = Math.abs($thumb[0].getBoundingClientRect().left),
			thumbRight = $thumb[$thumb.length -1].getBoundingClientRect().right - thumbW,
			scrollSpace = holderW - (windowW + thumbW);

		trace.push('[toggleArrows] thumbLeft ' + thumbLeft);
		trace.push('[toggleArrows] thumbRight ' + thumbRight);

		// if (dir == 'left' && thumbLeft < scrollSpace ) {
		// 	trace.push('[toggleArrows] hide Left Arrow');
		// 	$arrowL.addClass('hide');
		// }
		if (dir == 'left' && arrowCounter == 0 ) {
			trace.push('[toggleArrows] hide Left Arrow');
			$arrowL.addClass('hide');
		}
		else {
			$arrowL.removeClass('hide');
		}

		if(dir == 'right' && (thumbRight + scrollSpace) <= windowW) {
			$arrowR.addClass('hide');
			trace.push('[toggleArrows] hide Right Arrow');
		}
		 else {
			$arrowR.removeClass('hide');
		}
		if(arrowCounter + initialDisplayNumber == allData.length +2){
			$arrowR.addClass('hide');
			trace.push('[toggleArrows] hide Right Arrow');
		}
		else {
			$arrowR.removeClass('hide');
		}
	}

	$(function(){
		init();
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);